export default __webpack_public_path__ + "static/media/condense-icon-desktop.c6cbf0c0.svg";